<header
	class="w-full h-16 flex px-8 justify-between items-center bg-primary flex-grow-0 flex-shrink-0"
>
	<img
		src="images/wordmark-white.png"
		class="h-8"
		alt="Marmon Holdings, Inc Logo"
	/>

	<div class="flex gap-8 items-center text-lg">
		<ng-content />
	</div>
</header>
